<template>
  <div style="padding-top: 85px;">
    <!-- 下载进度条模态框 -->
    <div v-show="progressVisible" class="progress-modal">
      <div class="progress-content">
        <div class="progress-header">
          <div class="progress-title">{{ progressText }}</div>
          <div class="progress-percentage">{{ progressValue.toFixed(2) }}%</div>
        </div>

        <!-- 文件详情信息 -->
        <div class="progress-file-info">
          <div class="info-item">
            <span class="info-label">文件名称:</span>
            <span class="info-value">{{ downloadInfo.fileName || '未知文件' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">文件大小:</span>
            <span class="info-value">{{ downloadInfo.fileSize || '计算中...' }}</span>
          </div>

          <!-- 进度条 -->
          <div class="progress-bar">
            <div class="progress-fill" :style="{ width: progressValue + '%' }"></div>
          </div>
        </div>


      </div>
    </div>
    <headerList></headerList>

    <div class="detail-box">
      <!-- 详情版心主要内容 -->
      <div class="detail-main">
        <div class="ptb-15 flex flex-y- flex-x-s f-14 c-66">
          <span>当前位置:</span>
          <router-link :to="{ path: '/index' }" class="ml-5 shou">首页</router-link>
          <span class="iconfont iconxiangyoujiantou mlr-5"></span>
          <span>{{ PIC_CAT ? PIC_CAT : '图片' }}</span>
          <span class="iconfont iconxiangyoujiantou mlr-5"></span>
          <span>{{ SYS_TOPIC }}</span>
        </div>

        <div class="flex flex-y-s mt-10">
          <!-- 左侧内容 -->
          <div class="img-detail-left bg-ff">
            <!-- 标题 -->
            <div class="title flex plr-20 ptb-15 b-b">
              <span class="f-26 c-66 bold flex-box">{{ SYS_TOPIC }}</span>
              <img class="ml-40 title-icon" src="../assets/detail-icon.png" alt="" />
            </div>
            <!-- 图片内容 -->
            <div class="p-20">
              <viewer :images="[LARGE_PATH]" v-show="!group_arr.length" :title="false">
                <img v-for="(src, index) in [LARGE_PATH]" :src="src" class="detail-img" />
              </viewer>
              <viewer :images="group_arr" v-show="group_arr.length" :title="false">
                <img v-for="(src, index) in group_arr" :src="src.coverPath" class="detail-img1"
                  :data-name="src.SYS_TOPIC" :class="group_index == index ? 'show' : ''" />
              </viewer>
              <!-- 组图显示 -->
              <div class="group_arr_box flex flex-x-c mt-20" style="flex-wrap: nowrap;" v-show="group_arr.length">
                <div class="img-btn" @click="changeGroupindex('-')">
                  <img src="../assets/image_left.png" />
                </div>
                <!-- <div v-for="item,index in group_arr" @click="changeGroupindex('c',index)" :class="index == group_index?'active':''" class="img-small" v-if="group_index>=5" v-show="index >= group_index && index <= group_index +5 "><img :src="item.coverPath" /></div> -->
                <!-- <div v-for="item,index in group_arr" @click="changeGroupindex('c',index)" :class="index == group_index?'active':''" class="img-small" v-if="group_index<5"><img :src="item.coverPath" /></div> -->
                <div v-for="(item, index) in group_arr" @click="changeGroupindex('c', index)"
                  :class="index == group_index ? 'active' : ''" v-show="isshowList == 1 && index <= 4"
                  class="img-small">
                  <img :src="item.coverPath" />
                </div>
                <div v-for="(item, index) in group_arr" @click="changeGroupindex('c', index)"
                  :class="index == group_index ? 'active' : ''" v-show="isshowList == 2 && (index > 4 && index <= 9)"
                  class="img-small">
                  <img :src="item.coverPath" />
                </div>
                <div v-for="(item, index) in group_arr" @click="changeGroupindex('c', index)"
                  :class="index == group_index ? 'active' : ''" v-show="isshowList == 3 && (index > 9 && index <= 15)"
                  class="img-small">
                  <img :src="item.coverPath" />
                </div>
                <div v-for="(item, index) in group_arr" @click="changeGroupindex('c', index)"
                  :class="index == group_index ? 'active' : ''" v-show="isshowList == 4 && (index > 15 && index <= 21)"
                  class="img-small">
                  <img :src="item.coverPath" />
                </div>
                <div v-for="(item, index) in group_arr" @click="changeGroupindex('c', index)"
                  :class="index == group_index ? 'active' : ''" v-show="isshowList == 5 && (index > 21 && index <= 27)"
                  class="img-small">
                  <img :src="item.coverPath" />
                </div>
                <div v-for="(item, index) in group_arr" @click="changeGroupindex('c', index)"
                  :class="index == group_index ? 'active' : ''" v-show="isshowList == 6 && (index > 27 && index <= 33)"
                  class="img-small">
                  <img :src="item.coverPath" />
                </div>
                <div v-for="(item, index) in group_arr" @click="changeGroupindex('c', index)"
                  :class="index == group_index ? 'active' : ''" v-show="isshowList == 7 && (index > 33 && index <= 39)"
                  class="img-small">
                  <img :src="item.coverPath" />
                </div>
                <div v-for="(item, index) in group_arr" @click="changeGroupindex('c', index)"
                  :class="index == group_index ? 'active' : ''" v-show="isshowList == 8 && (index > 39 && index <= 45)"
                  class="img-small">
                  <img :src="item.coverPath" />
                </div>
                <div v-for="(item, index) in group_arr" @click="changeGroupindex('c', index)"
                  :class="index == group_index ? 'active' : ''" v-show="isshowList == 9 && (index > 45 && index <= 51)"
                  class="img-small">
                  <img :src="item.coverPath" />
                </div>
                <div v-for="(item, index) in group_arr" @click="changeGroupindex('c', index)"
                  :class="index == group_index ? 'active' : ''" v-show="isshowList == 10 && (index > 51 && index <= 57)"
                  class="img-small">
                  <img :src="item.coverPath" />
                </div>
                <div class="img-btn" @click="changeGroupindex('+')">
                  <img src="../assets/image_right.png" />
                </div>
              </div>
              <!-- 组图显示 当前多少 共多少 -->
              <div v-show="group_arr.length" class="mt-10 t-c f-14 c-99">
                共{{ group_arr.length }}张图片，目前是第{{ group_index - 0 + 1 }}张图片
              </div>
            </div>
            <!-- 描述介绍 -->
            <ul class="detail-img-mask b-t b-b flex flex-x-s">
              <li class="t-c bold  b-r shou" :class="nav_index == 0 ? 'on' : ''" @click="changeIndex(0)">
                素材介绍
              </li>
              <!-- <li class="t-c bold b-r">下载记录</li> -->
              <li class="t-c bold b-r shou" :class="nav_index == 2 ? 'on' : ''" @click="changeIndex(2)">
                用户评价
              </li>
            </ul>
            <div class="detail-mask plr-20 pt-20 pb-40">
              <!-- 素材 -->
              <div v-show="nav_index == 0">
                <div class="f-14 c-33" v-html="SUCAIJIESHAO"></div>
                <p class="banquan f-12 mt-30">
                  版权信息：本站所有资源均受著作权保护，未经许可不得使用，不得转载，
                  摘编。如有问题请及时
                  <router-link class="route-a" :to="{ path: '/about?id=14&name=联系我们' }">
                    联系我们
                  </router-link>
                  。
                </p>
                <div class="flex flex-x-s mt-30 mb-10">
                  <span class="mr-15 f-16 c-33">分享:</span>
                  <share :config="config"></share>
                </div>
              </div>
              <!-- <div></div> -->

              <!-- 评论 -->
              <div class="" v-show="nav_index == 2">
                <!-- 评论发布表单 -->
                <div class="flex flex-y-s comment-add">
                  <img :src="picture" class="head-img" v-if="picture" />
                  <img v-else src="../assets/images/noface.gif" class="head-img" />
                  <div class="flex flex-box">
                    <textarea name="" id="" placeholder="说点什么吧" maxlength="200" class="flex-box"
                      v-model="content"></textarea>
                    <div class="add-btn shou" @click="commentAdd">我要评论</div>
                  </div>
                </div>
                <p v-show="username" class="f-12 c-66 mt-10 " style="padding-left: 90px;">
                  Hello {{ username }} ！
                </p>
                <!-- 评论列表 -->
                <div class="mt-50 comment-list">
                  <div class="f-16">
                    共有
                    <span class="f-26 c-f0">{{ com_totalCount }}</span>
                    条评论
                  </div>
                  <ul class="plr-30">
                    <li class="ptb-20 flex flex-y-s comment-detail" v-for="(item, index) in com_list">
                      <img :src="item.picture" class="head-img mr-30" v-if="item.picture" />
                      <img v-else src="../assets/images/noface.gif" class="head-img mr-30" />
                      <div class="flex-box flex">
                        <div class="flex-box">
                          <div class="flex">
                            <div>
                              <span class="name f-14">{{ item.loginName }}</span>
                              <span class="date f-12 c-c2 ml-10">{{ item.auditTime }}</span>
                            </div>
                            <div>{{ item.discussStatus == 0 ? '待审核' : '' }}</div>
                          </div>
                          <div class="mt-20 comment c-33 f-12">{{ item.content }}</div>
                        </div>
                        <!-- <span class="ml-50 num mr-10">{{index + 1}}F</span> -->
                      </div>
                    </li>
                  </ul>
                  <div class="c-c2 t-c mt-20 shou f-14" @click="commentNext" v-show="!last">
                    查看更多
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 右侧内容 -->
          <div class="img-detail-right">
            <div class="p-15 user-info  bg-ff">
              <!-- 谁-发布与什么时候 -->
              <div class=" flex flex-x-s">
                <!-- <img src="../assets/images/noface.gif" alt="" class="head"> -->
                <div class="ml-15">
                  <span style="color: #10c55b;margin-right: 5px;">
                    {{ SYS_AUTHORS ? SYS_AUTHORS : '平台' }}
                  </span>
                  于
                  <span style="color: #10c55b;margin-left: 5px;">{{ SYS_CREATED }}</span>
                  上传
                </div>
              </div>
              <!-- 原创-侵权 -->
              <div class=" flex flex-x-s mt-20 mb-10">
                <div class="flex flex-x-s">
                  <img class="vip-icon" src="../assets/images/detail-vip-icon.png" />
                  <span class="f-14 bold c-66 ml-5">原创作品</span>
                </div>
                <router-link :to="{ path: '/about?id=14&name=联系我们' }">
                  <div class="flex flex-x-s ml-20 shou">
                    <img class="vip-qq" src="../assets/images/detail-bz-icon.png" />
                    <span class="f-12 c-c2 ml-5">侵权投诉</span>
                  </div>
                </router-link>
              </div>
              <!-- 选套餐 -->
              <!-- <div class="flex flex-dir-col flex-c">
								<div class="tc-detail"></div>
								<div class="tc-detail"></div>
								<div class="tc-detail"></div>
							</div> -->
              <!-- 下载-收藏 -->
              <div class="flex mt-25 cz-btn">
                <div class="down-btn radius-5 flex-c c-ff shou" v-if="!price || is_buy" @click="dowLoadFile">
                  <span class="iconfont icondownload"></span>
                  <span class="f-16 ml-5">下载素材</span>
                </div>
                <div class="down-btn radius-5 flex-c c-ff shou" v-else @click="buydetail">
                  <span class="iconfont icongouwuche"></span>
                  <span class="f-16 ml-5">立即购买</span>
                </div>
                <div class="ml-10 flex-box collect-btn radius-5 flex-c shou" @click="collectopt">
                  <span class="iconfont" :class="isCollected ? 'iconzan1' : 'iconzan'"></span>
                  <span class="f-16 ml-5">{{ isCollected ? '取消收藏' : '收藏' }}</span>
                </div>
              </div>
              <!-- 数据 -->
              <div class="flex mt-5">
                <div class="flex-box flex-c c-c2">
                  <span class="iconfont iconyanjing f-14"></span>
                  <span class="f-14 ml-5">{{ lookCount }}</span>
                </div>
                <span class="f-16 c-c2">|</span>
                <div class="flex-box flex-c c-c2">
                  <span class="iconfont icondownload f-14"></span>
                  <span class="f-14 ml-5">{{ uploadCount }}</span>
                </div>
                <span class="f-16 c-c2">|</span>
                <div class="flex-box flex-c c-c2">
                  <span class="iconfont iconcollection2 f-14"></span>
                  <span class="f-14 ml-5">{{ collectCount }}</span>
                </div>
              </div>
            </div>
            <!-- 特邀设计师 -->
            <div class="detail-ty-box bg-ff mtb-10 flex plr-25 flex-x-s">
              <img src="../assets/images/detail-award-icon.png" class="mr-15" alt="" />
              <span class="f-16 c-33">特邀设计师供稿</span>
            </div>
            <!-- 资料 -->
            <div class="p-20 bg-ff">
              <div class="b-b plr-10 ptb-20 f-14 c-99">
                <div class="mt-10" :hidden="!detail_name">图片说明：{{ detail_name }}</div>
                <div class="mt-10" v-for="(item, index) in more">
                  {{ item.name }}：{{ item.value }}
                </div>
              </div>
            </div>
            <!-- 标签 -->
            <div class="plr-30 ptb-35 bg-ff mt-8" v-show="keywords.length">
              <p class="f-14 bold c-33">标签</p>
              <div class="flex flex-x-s">
                <div class="mt-8 mr-8 detail-design shou" @click="enterSearch('KEYWORDS_s', item)"
                  v-for="(item, index) in keywords">
                  {{ item }}
                </div>
              </div>
            </div>
            <!-- 相关素材 -->
            <div class="bg-ff mt-8" v-show="about_list.length">
              <p class="plr-10 ptb-15 f-16">相关素材</p>
              <div v-for="(item, index) in about_list">
                <div v-if="item" class="plr-25 ptb-15 b-t flex shou" @click="toImgdetail(item.docId, item.doclibId)">
                  <img :src="item.middlePath" alt="" class="detail-about-img radius-5 mr-20" />
                  <div class="flex-box">
                    <p class="f-16 c-29">{{ item.docName }}</p>
                    <p class="flex flex-x-s f-14 c-99 mt-15">
                      <span>{{ item.sysCreated }}</span>
                      <!-- <span class="ml-15">浏览：100</span> -->
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer-view></footer-view>
  </div>
</template>

<script>
import axios from 'axios';
import headerView from './header.vue';
import footerView from './footer.vue';
import headerList from './header_nav.vue';
export default {
  data() {
    return {
      config: {
        sites: ['weibo', 'douban', 'qzone', 'wechat']
      },
      nav_list: [],
      about_list: [], // 相关链接
      id: 0,
      tid: 0,
      LARGE_PATH: '', // 大图
      SYS_TOPIC: '', // 标题
      SUCAIJIESHAO: '', // 介绍
      SYS_CREATED: '', // 入库时间
      SYS_AUTHORS: '', // 作者
      ACT_SPOT: '', // 素材编号
      DPI_X: '', // x分辨率
      DPI_Y: '', // y分辨率
      FILE_SIZE: '', // 文件大小
      more: [], // 具体显示字段
      keywords: [],
      group_arr: [],
      group_index: 0,
      lookCount: 0,
      collectCount: 0,
      isCollected: false,
      doclibId: 0, // 文档类型id
      doclibCode: '', // 商品码 用于商品标示
      doclibName: '',
      isshowList: 1,
      nav_index: 0,
      content: '',
      picture: '',
      username: '',
      pageIndex: 1,
      com_totalCount: 0,
      com_totalPages: 0,
      com_list: [],
      detail_name: '',
      last: true,
      price: '',
      is_buy: '',
      RESOURCEID: 0,
      PIC_CAT: '',
      totalElements: 0,
      PIC_CATID: 0,
      uploadCount: 0,
      // 进度条相关属性
      progressVisible: false,
      progressValue: 0,
      progressText: '',
      downloadInfo: {
        fileName: '',
        fileSize: '',
        fileUrl: ''
      }

      // SYS_CREATED:""
    };
  },

  components: {
    headerView,
    headerList,
    footerView
  },

  created() {
    let _this = this;
    _this.id = _this.$route.query.id;
    _this.tid = _this.$route.query.tid;
    // this.bindNavlist()
    this.binddetailInfo();
    this.bindaboutList(); // 获取相关资源
  },

  async mounted() {
    let _this = this;
    // _this.$Spin.show()

    // location.reload()
    // this.dowLoadList()
    const lookCount_res = await this.util.lookCount(this.id);
    const uploadCount_res = await this.util.uoloadCount(this.id);
    const collect_res = await this.util.collectCount(this.id);
    const isCollect_res = await this.util.isCollect(this.id);
    const is_buy = await this.util.is_buy(this.id);
    _this.is_buy = is_buy.data;
    _this.lookCount = lookCount_res.browsecount;
    _this.uploadCount = uploadCount_res.downloadsnum;
    _this.collectCount = collect_res.collectcount;
    _this.isCollected = isCollect_res.isCollected;
    _this.picture = localStorage.getItem('picture');
    _this.username = localStorage.getItem('username');
    _this.commentList();
    // _this.$Spin.hide()
  },

  methods: {
    // 获取详情信息
    async binddetailInfo() {
      let _this = this;
      _this.$Spin.show();
      const res = await _this.get_res('/docs/' + _this.id + '?sld=AHSCXB&docLibId=' + _this.tid);
      console.log('组图之前的接口', res);
      if (res) {
        _this.LARGE_PATH = res.MIDDLE_PATH || res.middlePath;
        _this.SYS_CREATED = res.SYS_CREATED || res.sysCreated;
        _this.SYS_TOPIC = res.SYS_TOPIC || res.docName;
        document.title = _this.SYS_TOPIC;
        _this.SUCAIJIESHAO = res.SUCAIJIESHAO || res.DESCRIPTION;
        _this.FILE_SIZE = res.FILE_SIZE;
        _this.SYS_AUTHORS = res.SYS_AUTHORS || res.AUTHORS || res.sysAuthors;
        _this.doclibId = res.doclibId || res.sysDoclibid;
        _this.doclibName = res.doclibName;
        _this.doclibCode = res.doclibCode;
        _this.price = res.PRICE || 0;
        _this.RESOURCEID = res.RESOURCEID || 0;
        _this.PIC_CAT = res.PIC_CAT || res.FENLEI;
        _this.PIC_CATID = res.PIC_CATID;
        if (res.keywords != '' && res.keywords != null) {
          _this.keywords = res.keywords.split(',') || [];
        }
        // if (res.sysDoclibid == 837) {
        if (res.SYS_DOCLIBID == 837) {
          _this.groupImginfo();
        } else {
          _this.$Spin.hide();
        }
        res.more.forEach(x => {
          if (x.name == '素材大小') {
            x.value = ((x.value - 0) / 1024 / 1024).toFixed(1) + 'M';
          }
        });
        _this.more = res.more;
      }
    },

    // 点击去支付
    async buydetail() {
      let _this = this;
      const res = await _this.util.checkToken();
      if (res.result == 0) {
        return _this.util.showMsg('warning', res.error.errorMsg, 3, false);
      }
      console.log(res);
      let params = {
        thirdIden: _this.id,
        LARGE_PATH: _this.LARGE_PATH,
        doclibName: _this.doclibName,
        SYS_TOPIC: _this.SYS_TOPIC,
        price: _this.price
      };
      _this.$router.push({ path: '/payMant', query: params });
    },

    // 去下载
    async dowLoadFile() {

      let _this = this;
      const res = await _this.util.checkToken();
      if (res.result == 0) {
        return _this.util.showMsg('warning', res.error.errorMsg, 3, false);
      }
      // 判断身份是否为作者
      let authorStatus = localStorage.getItem('authorStatus');
      if (authorStatus == 0) {
        console.log(authorStatus);
        this.$Message.error({
          content: '您不是投稿者,不能下载',
          duration: 3
        });
        return false
      }


      // 设置文件基本信息
      _this.downloadInfo.fileName = _this.SYS_TOPIC;
      _this.downloadInfo.fileSize = '计算中...';

      // 调用下载接口
      const data = await _this.put(
        '/members/downloads',
        JSON.stringify({ doclibid: _this.doclibId, docId: _this.id - 0, pageNo: 1 })
      );


      this.dowLoadList();


      if (_this.doclibId == 837) {
        console.log('多张图');
        // 设置多图下载URL信息
        _this.downloadInfo.fileUrl = `/pub/api/members/downLoadFileBatch`;

        // 显示进度条
        _this.progressVisible = true;
        _this.progressValue = 0;
        _this.progressText = '准备下载文件...';

        let ids = _this.group_arr.map(x => x.RESOURCEID);

        this.downLoadXls({ ids, name: _this.SYS_TOPIC }, _this.SYS_TOPIC);
      } else {
        // 设置单图下载URL信息
        const downloadUrl = _this.$baseURL + '/pub/prodb/attach/api/downLoadFile?recodeID=' + _this.RESOURCEID;
        _this.downloadInfo.fileUrl = downloadUrl;

        // 显示进度条
        _this.progressVisible = true;
        _this.progressValue = 0;
        _this.progressText = '准备下载文件...';

        _this.downloadWithProgress(downloadUrl, _this.SYS_TOPIC);
      }


      // let data = await _this.get_down('/downLoadFile?recodeID=' + _this.RESOURCEID)
    },
    // 使用XMLHttpRequest实现带进度监听的文件下载
    downloadWithProgress(url, fileName) {
      let _this = this;

      // 确保进度条显示
      _this.progressVisible = true;
      _this.progressValue = 0;
      _this.progressText = '准备下载文件...';

      // 首先发送HEAD请求获取文件大小
      const headXhr = new XMLHttpRequest();
      headXhr.open('HEAD', url, true);
      headXhr.addEventListener('load', function () {
        // 获取文件大小
        const contentLength = headXhr.getResponseHeader('content-length');
        if (contentLength) {
          const fileSizeBytes = parseInt(contentLength, 10);
          _this.downloadInfo.fileSize = _this.formatFileSize(fileSizeBytes);
        } else {
          _this.downloadInfo.fileSize = '未知大小';
        }
      });
      headXhr.send();

      const xhr = new XMLHttpRequest();

      // 监听下载进度
      xhr.addEventListener('progress', function (e) {
        if (e.lengthComputable) {
          // 计算下载进度百分比
          const percentComplete = (e.loaded / e.total) * 100;
          // 更新进度条，确保进度条显示平滑增长
          if (percentComplete <= 95) { // 保留5%给文件处理完成
            _this.progressValue = percentComplete;
            _this.progressText = `下载中...`;
            // 更新已下载大小显示
            const downloadedSize = _this.formatFileSize(e.loaded);
            const totalSize = _this.formatFileSize(e.total);
            _this.downloadInfo.fileSize = `${downloadedSize} / ${totalSize}`;
          }
        }
      });

      // 下载完成事件
      xhr.addEventListener('load', function () {
        if (xhr.status === 200) {
          // 设置进度为100%
          _this.progressValue = 100;
          _this.progressText = '下载完成！';

          // 创建下载链接
          const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('content-type') });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          // 确保文件名正确
          if (!fileName || fileName.trim() === '') {
            fileName = 'download_file';
          }
          // 从响应头获取文件名（如果存在）
          const contentDisposition = xhr.getResponseHeader('content-disposition');
          if (contentDisposition) {
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
            if (matches && matches[1]) {
              fileName = matches[1].replace(/['"]/g, '');
            }
          }
          a.download = fileName;
          document.body.appendChild(a);
          a.click();

          // 清理
          setTimeout(() => {
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            // 延迟关闭进度条
            setTimeout(() => {
              _this.progressVisible = false;
            }, 500);
          }, 0);
        } else {
          _this.progressText = '下载失败！';
          _this.util.showMsg('error', '文件下载失败', 3, false);
          setTimeout(() => {
            _this.progressVisible = false;
          }, 1500);
        }
      });

      // 下载错误事件
      xhr.addEventListener('error', function () {
        _this.progressText = '下载出错！';
        _this.util.showMsg('error', '网络错误，下载失败', 3, false);
        setTimeout(() => {
          _this.progressVisible = false;
        }, 1500);
      });

      // 设置响应类型为blob
      xhr.responseType = 'blob';

      // 发送请求
      xhr.open('GET', url);
      xhr.send();
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    // 获取uuid
    getUuid(ids, name) {
      axios({
        method: 'get',
        url: `/pub/api/members/zipFile?recodeIds=${ids}`, // 请求地址
        // data: form // 参数
        // timeout: 60000,
        // responseType: 'arraybuffer' // 表明返回服务器返回的数据类型
      })
        .then(response => {
          // 处理返回的文件流
          // console.log('uuid', response.data);
          // return
          if (response.data.status == 0) {
            this.getBolbData(response.data.msg, name)
          } else {
            setTimeout(() => {
              this.getUuid(ids, name)
            }, 500)
          }
        })
        .catch(res => {
          // console.log('2');
        });
    },
    downLoadXls(form, fileName) {

      let _this = this;
      // http://www.tpahw.com/pub/api/members/material/downloadFile
      // application/octet-stream
      // _this.$Spin.show({
      //   render: h => {
      //     return h('div', [
      //       h('Icon', {
      //         class: 'demo-spin-icon-load',
      //         props: {
      //           type: 'ios-loading',
      //           size: 18
      //         }
      //       }),
      //       h('div', '下载中111111')
      //     ]);
      //   }
      // });
      this.getUuid(form.ids, fileName);
      return false

    },

    // 获取文件数据
    getBolbData(uuid, fileName) {
      let _this = this;
      const url = `/pub/api/members/downLoadFileBatch?uuid=${uuid}&name=${fileName}`;

      // 显示进度条并更新文件信息
      _this.progressVisible = true;
      _this.progressValue = 0;
      _this.progressText = '准备下载文件...';
      _this.downloadInfo.fileName = fileName + '.zip';
      _this.downloadInfo.fileUrl = url;
      _this.downloadInfo.fileSize = '计算中...';

      // 先发送HEAD请求获取文件大小
      axios({
        method: 'head',
        url: url,
        timeout: 60000
      }).then(headResponse => {
        const contentLength = headResponse.headers['content-length'];
        if (contentLength) {
          const fileSizeBytes = parseInt(contentLength, 10);
          _this.downloadInfo.fileSize = _this.formatFileSize(fileSizeBytes);
        }
      }).catch(() => {
        // HEAD请求失败不影响主下载
        _this.downloadInfo.fileSize = '未知大小';
      });

      axios({
        method: 'get',
        url: url, // 请求地址
        timeout: 300000,
        responseType: 'arraybuffer', // 表明返回服务器返回的数据类型
        // 添加下载进度监听
        onDownloadProgress: function (e) {
          if (e.lengthComputable) {
            // 计算下载进度百分比
            const percentComplete = (e.loaded / e.total) * 100;
            // 更新进度条，确保进度条显示平滑增长
            if (percentComplete <= 95) { // 保留5%给文件处理完成
              _this.progressValue = percentComplete;
              _this.progressText = `下载中...`;
              // 更新已下载大小显示
              const downloadedSize = _this.formatFileSize(e.loaded);
              const totalSize = _this.formatFileSize(e.total);
              _this.downloadInfo.fileSize = `${downloadedSize} / ${totalSize}`;
            }
          }
        }
      })
        .then(response => {
          // 处理返回的文件流
          _this.$Spin.hide();
          // 下载完成后设置进度条为100%
          _this.progressValue = 100;
          _this.progressText = '下载完成！';

          // 更新最终文件大小
          const contentLength = response.headers['content-length'] || response.data.byteLength;
          if (contentLength) {
            _this.downloadInfo.fileSize = _this.formatFileSize(parseInt(contentLength, 10));
          }

          const filename = fileName + '.zip';
          const contentType = response.headers['content-type'];
          //创建 blob对象
          let blob = new Blob([response.data], {
            type: contentType
          });
          //生成生成下载链接
          let linkElement = document.createElement('a');
          let url = window.URL.createObjectURL(blob);
          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          linkElement.setAttribute('download', filename);
          //模拟点击a标签
          if (typeof MouseEvent == 'function') {
            var event = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: false
            });
            linkElement.dispatchEvent(event);
          }

          // 清理
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            // 延迟关闭进度条
            setTimeout(() => {
              _this.progressVisible = false;
            }, 500);
          }, 0);
        })
        .catch(res => {
          console.error('下载错误:', res);
          _this.progressText = '下载失败！';
          _this.util.showMsg('error', '文件下载失败，请稍后重试', 3, false);
          setTimeout(() => {
            _this.progressVisible = false;
          }, 1500);
        });
    },

    // 格式化文件大小为可读格式
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      if (isNaN(bytes)) return '未知大小';

      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    async dowLoadList() {
      let _this = this;
      const data1 = await _this.get_res('/members/downloads', {
        doclibid: 25,
        docId: _this.id - 0,
        pageNo: 3
      });
      _this.totalElements = data1.totalElements;
    },

    // 进入搜索页面
    enterSearch(field, q) {
      let link = this.$router.resolve({ path: '/search_list', query: { field, q } });
      window.open(link.href, '_blank');
    },

    // 获取相关资源
    async bindaboutList() {
      let _this = this;
      const res = await _this.get_res(
        '/docs/' + _this.id + '/getRelResources?sld=AHSCXB&size=4&destDocLibID=' + _this.tid
      );
      // console.log(2222222, res);
      if (res) {
        _this.about_list = res;
      }
    },

    // 跳转到图片详情
    toImgdetail(id, tid) {
      this.$router.push({ path: '/img_detail', query: { id, tid } });
    },

    // 跳转
    bindlinkTo(path, name) {
      if (path == '/index') {
        this.$router.push({ path, query: { name } });
      } else {
        let link = this.$router.resolve({
          path, //要跳转的路由
          query: {
            name
          }
        });
        window.open(link.href, '_blank'); //打开新窗口
      }
    },

    // 如果是组图获取组图信息
    async groupImginfo() {
      let _this = this;
      _this.$Spin.show();
      const res = await _this.get_res('/docs/' + _this.id + '/getGroupMembers');
      console.log('组图信息', res);
      _this.group_arr = res;
      _this.$Spin.hide();
      if (!res.length) {
        return;
      }
      _this.detail_name = res[0].SYS_TOPIC || '';
      _this.RESOURCEID = res[0].RESOURCEID || '';
      // _this.group_src = res[0].coverPath
    },

    // 改变多图索引
    changeGroupindex(type, index) {
      if (type == '-' && this.group_index != 0) {
        this.group_index = this.group_index - 1;
        this.detail_name = this.group_arr[this.group_index].SYS_TOPIC;
        this.RESOURCEID = this.group_arr[this.group_index].RESOURCEID;
        // this.group_src = this.group_arr[this.group_index].coverPath
      }
      if (type == '+' && this.group_index != this.group_arr.length - 1) {
        this.group_index = this.group_index + 1;
        this.detail_name = this.group_arr[this.group_index].SYS_TOPIC;
        this.RESOURCEID = this.group_arr[this.group_index].RESOURCEID;
        // this.group_src = this.group_arr[this.group_index].coverPath
      }
      if (type == 'c') {
        this.group_index = index;
        this.detail_name = this.group_arr[this.group_index].SYS_TOPIC;
        this.RESOURCEID = this.group_arr[this.group_index].RESOURCEID;
        // this.group_src = this.group_arr[this.group_index].coverPath
      }
      if (this.group_index <= 4) {
        this.isshowList = 1;
      }
      if (this.group_index > 4 && this.group_index <= 9) {
        this.isshowList = 2;
      }
      if (this.group_index > 9 && this.group_index <= 15) {
        this.isshowList = 3;
      }
      if (this.group_index > 15 && this.group_index <= 21) {
        this.isshowList = 4;
      }
      if (this.group_index > 21 && this.group_index <= 27) {
        this.isshowList = 5;
      }
      if (this.group_index > 27 && this.group_index <= 33) {
        this.isshowList = 6;
      }
      if (this.group_index > 33 && this.group_index <= 39) {
        this.isshowList = 7;
      }
      if (this.group_index > 39 && this.group_index <= 45) {
        this.isshowList = 8;
      }
      if (this.group_index > 45 && this.group_index <= 51) {
        this.isshowList = 9;
      }
      if (this.group_index > 51 && this.group_index <= 57) {
        this.isshowList = 10;
      }
    },

    // 收藏操作
    async collectopt() {
      let _this = this;
      if (_this.isCollected) {
        const res = await _this.util.collect_del(_this.doclibId, _this.id);
        _this.$Message.success({
          content: '取消收藏成功',
          duration: 3
        });
      } else {
        const res = await _this.util.collect(_this.doclibId, _this.id);
        if (res.code == 401) {
          return _this.$Message.error({
            content: res.message,
            duration: 3
          });
        }
        if (res.iFace) {
          _this.$Message.success({
            content: res.iMessage,
            duration: 3
          });
        }
      }
      const collect_res = await this.util.collectCount(this.id);
      const isCollect_res = await this.util.isCollect(this.id);
      _this.collectCount = collect_res.collectcount;
      _this.isCollected = isCollect_res.isCollected;
    },

    changeIndex(index) {
      this.nav_index = index;
    },

    // 获取评论列表接口
    async commentList(isPage = false) {
      let _this = this;
      let data = {
        articleId: _this.id,
        type: 3,
        libId: _this.doclibId,
        pageNumber: _this.com_totalPages,
        pageSize: 6
      };
      const res = await _this.post(
        '/spc/discuss/getDiscussList.do?article=' +
        _this.id +
        '&type=3' +
        '&libId=' +
        _this.doclibId +
        '&pageNumber=' +
        _this.com_totalPages +
        '&pageSize=6'
      );
      if (res.status == 0) {
        _this.com_totalCount = res.data.totalElements;
        _this.last = res.data.last;
        if (isPage) {
          _this.com_list = [..._this.com_list, ...res.data.content];
        } else {
          _this.com_list = res.data.content;
        }
      }
    },

    // 下一页评论
    commentNext() {
      let _this = this;
      _this.com_totalPages++;
      _this.commentList(true);
    },

    // 发布新评论
    async commentAdd() {
      let _this = this;

      if (_this.content == '') {
        return _this.$Message.warning('评论内容不能为空');
      }
      let data = {
        articleId: _this.id,
        articleTopic: _this.SYS_TOPIC,
        channel: 0,
        parentDiscussId: 0,
        parentId: 0,
        siteId: 110,
        type: 3,
        userId: localStorage.getItem('id'),
        userName: localStorage.getItem('username'),
        doclibId: _this.doclibId,
        doclibName: _this.doclibName,
        starScore: 10,
        content: _this.content
      };
      // const res = await _this.post_res('/members/addComment', data)
      const res = await _this.post('/spc/discuss/saveDiscuss.do', data);
      if (res.status == 0) {
        _this.$Message.success(res.message);
        _this.content = '';
        // setTimeout(() => {window.location.reload()},1500)
        _this.commentList();
      } else {
        _this.$Message.warning(res.message);
      }
    }
  },

  // 监听器监听路由的变化
  watch: {
    async $route(to, from) {
      let _this = this;
      _this.id = _this.$route.query.id;
      _this.tid = _this.$route.query.tid;
      // 做一些路由变化的响应
      this.binddetailInfo();
      this.bindaboutList(); // 获取相关资源
      // this.dowLoadList()
      const lookCount_res = await this.util.lookCount(this.id);
      const uploadCount_res = await this.util.uoloadCount(this.id);
      const collect_res = await this.util.collectCount(this.id);
      const isCollect_res = await this.util.isCollect(this.id);
      const is_buy = await this.util.is_buy(this.id);

      _this.is_buy = is_buy.data;

      _this.lookCount = lookCount_res.browsecount;
      _this.collectCount = collect_res.collectcount;
      _this.isCollected = isCollect_res.isCollected;
      _this.uploadCount = uploadCount_res.downloadsnum;
      _this.picture = localStorage.getItem('picture');
      _this.username = localStorage.getItem('username');
      _this.commentList();
    }
  },

  beforeDestroy() {
    document.title = '图片安徽';
  }
};
</script>

<style lang="less">
/* 进度条样式 - 类似360下载管理器 */
.progress-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  .progress-content {
    background: #fff;
    border-radius: 8px;
    width: 500px;
    height: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    overflow: hidden;

  }

  .progress-header {
    background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
    color: white;
    padding: 15px 20px;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
    border-bottom: none;
  }

  .progress-header::before {
    content: "⇓";
    margin-right: 10px;
    font-size: 18px;
  }

  .progress-body {
    padding: 20px;
  }

  .progress-title {
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 15px;
  }

  .progress-percentage {
    font-size: 14px;
    color: #fff;
    font-weight: bold;
  }

  .progress-file-info {

    padding: 20px;
  }

  .info-item {
    display: flex;
    margin-bottom: 8px;
    font-size: 13px;
    line-height: 1.6;
  }

  .info-label {
    width: 80px;
    color: #999;
  }

  .info-value {
    flex: 1;
    color: #333;
    text-align: left;
    word-break: break-all;
  }

  .url-text {
    font-size: 12px;
    color: #999;
    word-break: break-all;
  }

  .progress-bar {
    width: 100%;
    height: 12px;
    background: #f0f0f0;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 15px;
    position: relative;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
  }

  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #1890ff 0%, #52c41a 100%);
    transition: width 0.3s ease;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
      animation: shimmer 2s infinite;
    }
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}



.detail-box {
  background-color: #f1f2f6;
  padding-bottom: 120px;
}

.detail-main {
  width: 1200px;
  margin: 0 auto;
}

.iconxiangyoujiantou {
  font-size: 12px;
  color: #666;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

// 图片详情左侧内容
.img-detail-left {
  width: 800px;

  .title-ion {
    width: 22px;
    height: 27px;
  }

  .detail-img {
    box-shadow: rgba(0, 0, 0, 0.15) 0 0 8px;
    border: 1px solid #ddd;
    border-radius: 3px;
    width: 760px;
    height: auto;
    cursor: pointer;
  }

  .detail-img-mask {
    height: 60px;
    background-color: #cfd8dc;

    li {
      width: 100px;
      height: 100%;
      line-height: 60px;
      color: #78909c;
      font-size: 14px;
    }

    .on {
      background-color: #fff;
      color: #000;
    }
  }
}

.detail-mask {
  .banquan {
    background-color: #f9f2e6;
    border: 1px #f4e6cf solid;
    padding: 15px 15px;
    border-radius: 5px;
  }
}

.img-detail-right {
  width: 385px;
}

.user-info {
  .head {
    width: 36px;
    height: 36px;
    border-radius: 50%;
  }

  .vip-icon {
    width: 25px;
    height: 19px;
  }

  .vip-qq {
    width: 13px;
    height: 17px;
  }

  .tc-detail {
    width: 320px;
    height: 50px;
    background-color: #f8f8f8;
    margin-top: 12px;
  }

  .down-btn {
    width: 190px;
    height: 52px;
    background-color: #4b6ea6;
  }

  .collect-btn {
    height: 52px;
    border: 1px solid #4b6ea6;
    color: #4b6ea6;
    background-color: #eff4fa;
  }

  .cz-btn {
    width: 320px;
    margin: 25px auto 7px;
  }
}

.detail-ty-box {
  height: 70px;
}

.detail-design {
  padding: 2px 10px;
  border: 1px solid #ececec;
}

.detail-about-img {
  width: 110px;
  height: auto;
}

// 组图显示
.group_arr_box {
  >.img-small {
    // width: 100px;
    // height: 66px;
    margin: 0 10px;
    cursor: pointer;
  }

  .img-small.active {
    border: 2px solid #ffb017;
  }

  >.img-btn {
    width: 18px;
    height: 72px;
    cursor: pointer;
  }

  img {
    width: auto;
    height: 66px;
  }
}

.img-detail-left .detail-img1 {
  box-shadow: rgb(0 0 0 / 15%) 0 0 8px;
  border: 1px solid #ddd;
  border-radius: 3px;
  width: 760px;
  margin: 0 auto;
  height: auto;
  cursor: pointer;
  display: none;
}

.img-detail-left .detail-img1.show {
  display: block;
}

// 新家评论
.comment-add {
  .add-btn {
    background-color: #339ef4;
    color: #fff;
    width: 138px;
    height: 138px;
    line-height: 138px;
    font-size: 14px;
    text-align: center;
  }

  textarea {
    height: 138px;
    border: 1px solid #cbcbcb;
    padding: 10px;
    box-shadow: inset 0 1px 2px rgb(0 0 0 / 12%);
    resize: none;
  }

  .head-img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 40px;
  }
}

.comment-list {
  .head-img {
    width: 44px;
    height: 44px;
    border-radius: 50%;
  }

  .comment-detail {
    border-bottom: 1px solid #eee;
  }

  .num {
    font-size: 19px;
    font-style: italic;
    font-family: 'Open Sans', Arial, sans-serif;
    color: #c8c8c8;
  }

  .name {
    color: #2196f3;
  }

  .date {
    color: #b0bec5;
  }
}

input:focus,
textarea:focus {
  outline: none;
}
</style>
